import React from "react";

class ViewerErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err) {
    // 3D rendering failed — most commonly due to WebGL context issues
    // or dev-instrumentation props being passed to three.js objects.
    // Silently fall back to the 2D view.
    console.warn("3D viewer error, falling back:", err?.message);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="w-full h-full bg-[#0a0a0a] border border-zinc-800 grid-bg relative flex items-center justify-center">
            <div className="text-center">
              <div className="text-[#ff3333] text-[10px] tracking-[0.3em] uppercase mb-2">// 3D_UNAVAILABLE</div>
              <div className="text-zinc-600 text-xs">Use photo view instead</div>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ViewerErrorBoundary;
